import { inject, bindable, BindingMode, IEventAggregator } from "aurelia";
import { I18N } from "@aurelia/i18n";
import { IRouter } from "@aurelia/router";
import { SignatureService } from "../../services/signature-service";
import jwt_decode from "jwt-decode";
import QRious from 'qrious';
import { b64decode } from "../../b64";
import { FormFieldChanged } from "../../messages/form-field-changed";

@inject(SignatureService, IEventAggregator, IRouter)
export class BankidSignatureCustomElement {
    @bindable fieldName;
    @bindable fieldValue;
    @bindable referenceDisplay;
    @bindable displayCallback;

    autoStartToken = ''
    cancelled = false;
    orderRef = null;

    constructor(SignatureService, eventAggregator, router) {
        this.signatureService = SignatureService;
        this.eventAggregator = eventAggregator;
        this.router = router;
    }

    tryCancel() {
        if (this.orderRef != null) {
            this.signatureService.cancel(this.orderRef);
        }
        this.orderRef = null;
        this.cancelled = true;
    }

    attached() {
      this.afterAttached();
    }

    async afterAttached() {
        let signature = await this.getSignature();
        if (signature !== undefined) {
            this.signature = signature;
            return
        }

        if (this.referenceDisplay == null) { //?
            let referenceDisplay = 'Signera'
            const customer = this.router?.currentRoutingInstruction?.params?.customer ?? undefined;
            if (customer !== undefined) {
                referenceDisplay += ` ${customer}`;
            }
            this.referenceDisplay = referenceDisplay;
        }
        this.qr = new QRious({ element: this.canvas, size: 180, value: '' });
    }

    async sign() {
        this.autoStartToken = ''
        this.cancelled = false;
        this.orderRef = null;

        if (this.displayCallback) {
            this.referenceDisplay = this.displayCallback();
        }

        const { frames, autoStartToken, orderRef } = await this.signatureService.v2sign(this.referenceDisplay);
        this.autoStartToken = autoStartToken;
        this.orderRef = orderRef;

        let user = {};

        await this.sleep(1000);
        for (let i = 1; ; i++) {
            if (this.cancelled) {
                this.status = 'failed';
                break;
            }

            let x = await this.signatureService.v2status(this.orderRef);
            user = x.completionData.user;

            this.qr.set({ value: frames[i] });
            this.status = x.status;
            this.hintCode = x.hintCode;

            if (this.status !== 'pending') {
                break;
            }

            await this.sleep(1000);
        }

        if (this.status === "complete") {
            this.signature = {
                fullName: user.name,
                updated: new Date().toISOString().slice(0, 10),
                bankIdOrderRef: this.orderRef,
            }
            let formfieldChanged = new FormFieldChanged(this.fieldName, this.orderRef, this.orderRef, null, null, null);
            this.eventAggregator.publish(formfieldChanged);

        }
        if (this.status == 'failed') {
            this.hintCode = null;
        }
    }

    async getSignature() {
        if (this.fieldValue === undefined) {
            return undefined;
        }
        const signatures = await this.signatureService.getByReferenceId(this.fieldValue);
        let signedSignatures = signatures.filter(x => x.fullName !== "");
        if (signedSignatures.length > 0) {
            return signedSignatures[0];
        }
    }

    cancel() {
        this.tryCancel();
    }

    sleep = ms => new Promise(r => setTimeout(r, ms));
}
